import { List, Tiles } from "theme/icons";

export enum EBookingListView {
  LIST = "list",
  GRID = "grid",
}

export enum EScheduleOptions {
  WEEK = "week",
  DAY = "day"
}

export const ViewOptionsConfig = [
  { value: EBookingListView.LIST, label: <List/> },
  { value: EBookingListView.GRID, label: <Tiles/> },
]

export const ScheduleOptionsConfig = [
  { value: EScheduleOptions.WEEK, label: "Тиждень" },
  { value: EScheduleOptions.DAY, label: "День" },
]
